import defu from 'defu'
import { refreshCookie, UseFetchOptions } from 'nuxt/app'
import { RuntimeConfig } from 'nuxt/schema'

export const useApi = <T>(url: string | (() => string), options: UseFetchOptions<T> = {}) => {
  const { $auth } = useNuxtApp()
  const errorStore = useErrorStore()
  const config: RuntimeConfig = useRuntimeConfig()

  const router = useRouter()

  const defaults: UseFetchOptions<T> = {
    baseURL: `${config.public.API_URL}/v1`,
    retry: 1,
    retryStatusCodes: [401],
    retryDelay: 500,
    onRequest({ options }) {
      const token = useCookie('auth._token.oidc')

      if ($auth.loggedIn) {
        options.headers = {
          ...options.headers,
          Authorization: token.value,
          Accept: 'application/json',
        }
      }
    },
    onResponse: async response => {
      if (response.response.status === 401) {
        console.log('Refreshing token...')

        try {
          await $auth.refreshTokens()
        } catch (e) {
          console.error(e)

          // If refresh token is not successful, logout user and redirect to login page
          if ($auth.$state.loggedIn) await $auth.logout()
          await router.push('/login')
          return
        }

        refreshCookie('auth._token.oidc')
      }

      return response
    },
    onResponseError: async error => {
      if (Object.hasOwn(error.response._data, 'Message') && !errorStore.hasGlobalError(error.response._data.Message)) {
        errorStore.addGlobalError(error.response._data.Message)
      }
    },
  }

  return useFetch(url, defu(options, defaults))
}
